import cn from "classnames";
import { type PropsWithChildren, type ReactNode } from "react";
import Layout from "@/components/common/Layout";
import { type CategoryHeaderPosition } from "../constants";
import s from "./CategoryLayout.module.scss";

export interface CategoryLayoutProps {
  header: ReactNode;
  headerPosition: CategoryHeaderPosition;
  columnLayout: string;
}

export default function CategoryLayout(
  props: PropsWithChildren<CategoryLayoutProps>,
) {
  const { header, headerPosition, columnLayout, children } = props;
  const [leftColumn, rightColumn] = columnLayout.split(":");
  let content = (
    <div className="row g-4 g-md-5">
      <div className="col-12">{header}</div>
      <div className="col-12">{children}</div>
    </div>
  );

  if (headerPosition === "LEFT" || headerPosition === "RIGHT") {
    const rowClassName = cn("row g-4", {
      "flex-row-reverse": headerPosition === "RIGHT",
    });

    content = (
      <div className={rowClassName}>
        <div className={`col-12 col-md-${leftColumn}`}>{header}</div>
        <div className={`col-12 col-md-${rightColumn}`}>{children}</div>
      </div>
    );
  }

  return (
    <div className={s.wrapper}>
      <Layout containerOnly fluid>
        {content}
      </Layout>
    </div>
  );
}
